import { gql } from "@apollo/client";
import { EnforcementIntentDetail, enforcementIntentDetailFragment } from "../fragments";

export const APPLY_ENFORCEMENT_INTENT_CORRECTION = gql`
  mutation ApplyEnforcementIntentCorrection(
    $intentId: uuid!
    $licensePlateNumber: String!
    $licensePlateRegion: String!
  ) {
    appliedCorrection: apply_enforcement_intent_correction(
      intent_id: $intentId
      license_plate_number: $licensePlateNumber
      license_plate_region: $licensePlateRegion
    ) {
      correction {
        id
        intent {
          ...enforcementIntentDetailFragment
        }
      }
    }
  }
  ${enforcementIntentDetailFragment}
`;

export interface ApplyEnforcementIntentCorrectionData {
  appliedCorrection: {
    correction: {
      id: string;
      intent: EnforcementIntentDetail;
    };
  };
}

export interface ApplyEnforcementIntentCorrectionVars {
  intentId: string;
  licensePlateNumber: string;
  licensePlateRegion: string;
}

export default APPLY_ENFORCEMENT_INTENT_CORRECTION;
